var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ysbox"},[_c('div',[_c('van-nav-bar',{attrs:{"title":"隐私政策","left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1),_c('YS')],1)}
var staticRenderFns = []

export { render, staticRenderFns }